<template>
    <div class="inquiry_main">
        <p class="current">当前位置：<span>询价详情</span></p>
        <div class="inquiry_info">
            <div class='VSItem'>
				<div class='VSItemcon'>
                    <p>询价者：{{info.user_name}}</p>
                    <p class='VSTitle4'>时间：{{info.create_time}}</p>
					
				</div>
				<div class='VSItemCon2'>
                    <div class='VSTitle4 vsflex'>
                        <div class="vsflexone">询价产品：</div>
                    </div>
                    <div class="vsorders">
                        <div class="vsorderitems" v-for="(item,index) in info.product_list" :key="index">
                            <div class="vsimgcon">
                                <img :src="item.product_img" alt="">
                            </div>
                            <div class="vsInfo">
                                <p>{{ item.product_name }}</p>
                                <p class="gray" v-if="!(item.product_describe == '')">备注： {{ item.product_describe }}</p>
                                <p>数量：{{ item.quantity }}</p>
                                <p>预期价格：￥{{ item.expected_price }}</p>
                            </div>
                            
                        </div>
                        
                    </div>
                   
				</div>
                
				
				
			</div>    
        </div>
    </div>
</template>

<script>
import { getTimeDate } from '@/js/getTime'

export default{
    data(){
        return{
            id: -9,
            vsurl: '',
            vstoken:'',
            companytype: [],
            company_type_index: 0,
            company_type_id: '',
            company_type_name: '选择类别',
            info: {},
            form: {
                company_ids: '',
                cates: '',
                type: ''
            },
            name: '',
            code: '',
            real_name: '',
            phone: '',
            remarks: '',
            file_items: [],
            FileData:[],
            imgHeight:80,
            description: '',
            SKCode: '',
            audit_status: -9,
            vsid: -9,
            isedit: -9,
            products: [],
            products0: [
                {
                    product_name: '安全帽002',
                    product_describe: '特别防护',
                    quantity: 2,
                    product_img: 'https://qiliangong.oss-cn-shenzhen.aliyuncs.com/2023-07-04/a0f6f09f-2bb7-4b6b-8965-0a56b7b4140e.jpeg'
                }
            ],
            company_name: '',
            company_id: '',
            company_ids: '',
            product_form: {
                product_name: '',
                quantity: 1,
                product_describe: '',
                product_img: ''
            },
            product_name: '',
            quantity: 1,
            product_describe: '',
            product_img: '',
            pindex: -9,
            EditShow: false
        }
    },
    methods: {
        getInfo(data) {
            this.$store.dispatch('enable/details',data)
                .then(res => {
                    if(res.ok){
                        console.log('getDetail')
                        var info = res.data
                        console.log(info)
                        this.info = res.data
                        console.log(this.info)
                        this.info.create_time = getTimeDate(this.info.create_time)
                    }
                })
            
        },
        EditProduct(index){
            this.pindex = index
            var products = this.products
            var info = products[index]
            this.product_name = info.product_name
            this.product_describe = info.product_describe
            this.quantity = info.quantity
            this.product_img = info.product_img
            this.EditShow = true
        },
			
        DelProduct(index){
            var products = this.products
            products.splice(index, 1)
            this.products = products
        },
    },
    mounted(){
        this.id = this.$route.query.id
        let data = {
            id : this.id
        }

        this.getInfo(data)
    }
}
</script>

<style scoped lang="scss">
.inquiry_main{
    background: #fff;
    width: 1190px;
    padding-bottom: 30px;
    min-height: calc(100vh - 215px);
    margin: 45px auto;
    position: relative;
    .current{
       
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 17px;
            cursor: pointer;
            color: #666666;
        }
    }
    .inquiry_info{
        width: 1180px;
        margin: 25px auto;
        padding: 10px 0px;
        position: relative;
        .VSItem{
            padding: 10px 40px;
            font-size: 18px;
            color: #333333;
            .VSItemcon{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .VSTitle4{
                    font-size: 16px;
                    color: #666666;
                }
            }
            .vsorderitems{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                border-bottom: 1px solid #f2f2f2;
                margin-top: 10px;
                padding: 10px 20px 30px 20px;
                .vsimgcon{
                    width: 120px;
                    height: 120px;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    img{
                        width: 120px;
                        height: 120px;
                        object-fit: cover;
                        border-radius: 10px;
                    }
                }
                .vsInfo{
                    width: 900px;
                    margin-left: 20px;
                    p{
                        line-height: 30px;
                        color: #666666;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>